module.exports = __webpack_public_path__ + "src/assets/img/cushion_01_en.8be0004a.png";